import { createApi } from "@reduxjs/toolkit/dist/query/react"
import { LEAD_SCORING_SCORES_ENDPOINT } from "../../common/constants"
import { getQueryString } from "../../common/utils"
import { LeadScoreResponse, LeadScoreQueryParams } from "../../types"
import { baseQuery } from "../api"

const reducerPath = "leadScoring"

const EMPTY_STATS = {
  total: 0,
  hot_lead: 0,
  needs_contact: 0,
  engaged: 0,
  dormant: 0,
  at_risk: 0,
  avg_score: 0
}

export const leadScoringApi = createApi({
  reducerPath,
  baseQuery,
  tagTypes: [reducerPath],
  endpoints: builder => ({
    fetchLeadScores: builder.query<LeadScoreResponse, LeadScoreQueryParams>({
      query: params =>
        `${LEAD_SCORING_SCORES_ENDPOINT}${getQueryString(
          params as Record<string, string | number | boolean | undefined>
        )}`,
      transformResponse: (responseData: any): LeadScoreResponse => {
        // New shape: { status, data, pagination, stats }
        if (responseData?.data && !Array.isArray(responseData)) {
          return {
            data: responseData.data ?? [],
            pagination: responseData.pagination ?? {
              total: 0,
              limit: 50,
              offset: 0,
              page: 1,
              total_pages: 1
            },
            stats: responseData.stats ?? EMPTY_STATS
          }
        }
        // Legacy: bare array
        const arr = Array.isArray(responseData) ? responseData : []
        return {
          data: arr,
          pagination: {
            total: arr.length,
            limit: arr.length,
            offset: 0,
            page: 1,
            total_pages: 1
          },
          stats: EMPTY_STATS
        }
      }
    })
  })
})

export const { useFetchLeadScoresQuery } = leadScoringApi
